export enum PurchaseJourneyAnalyticsEnum {
  SLOT_CHOSEN = '[PAC WEB] Jornada de Compra - Escolheu horário',
}

export enum PurchaseJourney {
  UNIFIED = 'unificada',
}

export enum PurchaseJourneyAppointmentType {
  PRESENCIAL = 'presencial',
  TELECONSULTA = 'teleconsulta',
}
